import DemoBuilder from '../DemoBuilder';
import { DemoDefinitionBuilder } from '../DemoDefinitionBuilder';
import demoContent from "./DemoContent";

export default class DemoCreate extends DemoBuilder {

  build = () => {
    return new DemoDefinitionBuilder()
      .setDebugOn(false)
      .setRenderComputer(false)
      .setWidth(this.width)
      .setMarginLeft(150)
      .setMarginRight(0)
      .addInstructionGroupings([
        demoContent.addCreatePartAInstructions,
        demoContent.addCreatePartBInstructions,
      ])
      .build();
  }

}